import { render, staticRenderFns } from "./duoLandingPageMobile.vue?vue&type=template&id=b0d69c2c&scoped=true&"
import script from "./duoLandingPageMobile.vue?vue&type=script&lang=js&"
export * from "./duoLandingPageMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoLandingPageMobile.vue?vue&type=style&index=0&id=b0d69c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d69c2c",
  null
  
)

export default component.exports